<template>
    <div class="max-w-fit px-6 py-3 text-white border-2 border-orange-500 bg-orange-500 rounded hover:cursor-pointer uppercase">{{ content }}</div>
</template>

<script setup>
defineProps(['content'])
</script>